import { render, staticRenderFns } from "./aanmelden.vue?vue&type=template&id=0295b362"
import script from "./aanmelden.vue?vue&type=script&lang=js"
export * from "./aanmelden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports